module.exports = __webpack_public_path__ + "static/media/chevron-circle-left.bf0c5b1f.svg";